module.exports = __webpack_public_path__ + "img/ic-interpayment-no-color.4841a0ac.svg";